type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const PlatformIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M33.6662 3.74072H11.2221C9.15621 3.74072 7.48145 5.41548 7.48145 7.4814V37.4069C7.48145 39.4728 9.15621 41.1475 11.2221 41.1475H33.6662C35.7321 41.1475 37.4069 39.4728 37.4069 37.4069V7.4814C37.4069 5.41548 35.7321 3.74072 33.6662 3.74072Z"
        stroke={color}
        strokeWidth="3.74068"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4443 33.6661H22.4639"
        stroke={color}
        strokeWidth="3.74068"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
